var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"scroll-button",on:{"click":_vm.scrollToPosition,"dblclick":function($event){$event.stopPropagation();}}},[_c('Icons',{attrs:{"icon":_vm.icon,"height":"22px","width":"22px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }